import { createSlice } from '@reduxjs/toolkit';
import { fetchAclAccesses } from 'common/services/api/Acls/AclAccesses.thunk';
import { AclAccess } from 'common/types/Entities';
import { clearEntitiesReducer,createProcessingEntityInitialState, createProcessingExtraReducers, ProcessingEntityState } from 'common/utils/sliceUtils/entitySliceUtils';
import { filterReducers } from 'common/utils/sliceUtils/filterSliceUtils';

import type { RootState } from '../../app/store';

type AclAccessesState = ProcessingEntityState<AclAccess>;

const initialState: AclAccessesState = createProcessingEntityInitialState<AclAccess>();

const aclAccessesSlice = createSlice({
    name: 'aclAccesses',
    initialState,

    reducers: (create) => ({
        ...filterReducers,
        clearEntities: create.reducer(clearEntitiesReducer)
    }),

    extraReducers: builder => {
        createProcessingExtraReducers<AclAccess>(builder, fetchAclAccesses);
    }
});

// eslint-disable-next-line no-restricted-syntax
export default aclAccessesSlice.reducer;
export const { addNewFilter, removeFilter, clearFilters, clearEntities } = aclAccessesSlice.actions;
export const selectFilters = (state: RootState) => state.aclAccesses.filters;
export const selectEntities = (state: RootState) => state.aclAccesses.entities;
export const selectProcessing = (state: RootState) => state.aclAccesses.processing;
export const selectError = (state: RootState) => state.aclAccesses.error;
